export { SALUTATION, FIRST_NAME, LAST_NAME, EMAIL, STREET, POSTAL_CODE, CITY, COUNTRY } from "../_sub-forms/customer-data/field-names";
export var CUSTOMER = "customer";
export { METHOD, SEPA_ACCOUNT_OWNER, SEPA_IBAN, SEPA_BIC, SEPA_BANK, STRIPE_TOKEN } from "../_sub-forms/payment-method/field-names";
export var PAYMENT_METHOD = "payment_method";
export { AGB, PRIVACY } from "../_sub-forms/legal-agreement/field-names";
export var LEGAL_AGREEMENT = "legal";
